import { Either, mapLeft } from "fp-ts/lib/Either";
import { _Error, createErrorListFromUnknownError } from "@/lib/wordpress/data";
import { stringify } from "fp-ts/Json";
import { pipe } from "fp-ts/lib/function";

export function fpJsonStringify<T>(valueToEncode: T): Either<_Error[], string> {
  return pipe(
    valueToEncode,
    stringify,
    mapLeft(e =>
      createErrorListFromUnknownError(
        e,
        "Failed to stringify given value to JSON"
      )
    )
  );
}
